<template>
    <div class="filter">
        <div class="inputs">
            <Dropdown className="filter-input" @update="setSelected" :selectName="`${id}-select`" :options="searchableFields" :selected="urlSelected" label="Field to search"></Dropdown>
            <label :for="`${id}-input`" class="sr-only">Value to search in {{ selectedField }}</label>
            <input :name="slug(selectedField)" :id="`${id}-input`" type="text" v-model="searchTerm" />
            <Dropdown className="filter-input" @update="setBoolean" selectName="boolean" :options="booleanOptions" :selected="urlBoolean" label="Boolean for next field"></Dropdown>
            <div>
                <button class="circle-btn remove" type="button" @click="remove" :disabled="isFirst">
                    <span class="sr-only">{{ $t('labels.remove_filter') }}</span>
                </button>
                <button class="circle-btn add" type="button" @click="add" :disabled="isSeventh">
                    <span class="sr-only">{{ $t('labels.add_filter') }}</span>
                </button>
            </div>
        </div>

    </div>
</template>

<script>
import Dropdown from '../components/Dropdown'

export default {
    components: {
        Dropdown,
    },
    data: function () {
        return {
            id: null,
            selectedField: null,
            selectedBoolean: null,
            searchTerm: '',
            urlSelected: null,
            urlBoolean: null
        }
    },    
    props: {
        'isFirst': Boolean,
        'isSeventh': Boolean,
        'urlQuery': Object
    },
    computed: {
        searchableFields () {
           return this.$i18n.messages[this.$i18n.locale].search_fields;
        },
        booleanOptions () {
           return this.$i18n.messages[this.$i18n.locale].boolean_options;
        }
    },
    watch: {
        'urlQuery' (newVal, oldVal) {
            if (newVal != oldVal) {
                newVal.selected = 'Keywords/Description';
                this.setQuery(newVal);
            }
        }
    },
    methods: {
        add () {
            this.$emit('add');
        },
        remove () {
            this.$emit('remove', this.$vnode.key);
        },
        setSelected (value) {
            this.selectedField = value;
        },
        setBoolean (value) {
            this.selectedBoolean = value;
        },
        slug (name) {
            if (!name) return;
            return name.replaceAll(' ', '-').toLowerCase();
        },
        setQuery(data) {
            this.urlSelected = data.selected;
            this.urlBoolean = data.boolean;
            this.searchTerm = data.searchTerm;
        }
    },
    async mounted() {
        this.id = this._uid;

        if (this.urlQuery) {
            this.setQuery(this.urlQuery);
        }
    }
}
</script>

<style scoped lang="scss">

.filter {
    margin: .5rem 0;
    height: 51px;
    display: flex;
    align-items: center;

    .inputs {
        display: flex;
        justify-content: space-between;
        flex-grow: 1;

        input {
            @include input-styles;
        }

        // .split-inputs {
        //     display: flex;
        //     justify-content: space-between;
        //     align-items: center;
        //     &:first-of-type {
        //         flex-grow: 1;
        //     }    
        // }
    }

    .circle-btn {
        height: 22px;
        width: 22px;
        color: $white;
        background-color: $dark-gray1;
        border-radius: 50%;
        border: none;
        margin: 0 .15rem;
        padding: 0;

        &[disabled] {
            opacity: .6;
        }

        &.remove:after {
            content: url('../assets/images/icon-minus-white.svg');
            height: 18px;
            width: 18px;
            position: relative;
            top: 1px;
        }
        &.add:after {
            content: url('../assets/images/icon-plus-white.svg');
            height: 18px;
            width: 18px;
            position: relative;
            top: 1px;
        }
    }
}

@media (max-width: $mq-max-width-mobile) {

    .filter {
        height: unset;
        margin: 0;
        margin-bottom: 1.5rem;

        .inputs {
            flex-direction: column;

            > div {
                flex-grow: 1;
                width: 100%;
                margin-bottom: .5rem;
                // justify-content: flex-start;

                button {
                    margin-top: .75rem;
                }
            }

            input {
                margin-right: 0;
                width: 100%;
                margin-bottom: .5rem;
            }

            &:first-of-type {
                select {
                    max-width: unset;
                }
            }  
        }
    }
}
</style>